import React, { FC, ReactNode } from 'react';

import StateSection from '~/src/components/CourtForms/StateSection';
import type { TemplateMetadata } from '~/src/hooks/useGetTemplateMetadata';
import {
  type AdditionalRegionInfo,
  getFilterCategoriesForRegion,
} from '~/src/utils/additionalRegionForms';

interface Props {
  additionalRegions: AdditionalRegionInfo[];
  templateMetadata: TemplateMetadata;
  renderProvince: (region: AdditionalRegionInfo, province: string) => ReactNode;
}

const AdditionalRegionSections: FC<Props> = ({
  additionalRegions,
  templateMetadata,
  renderProvince,
}) => (
  <>
    {additionalRegions.map((region) => {
      const provinces = getFilterCategoriesForRegion(
        templateMetadata,
        region.region,
      );
      if (provinces.length === 0) return null;
      return (
        <StateSection key={region.region} stateName={region.label}>
          {provinces.map((province) => (
            <React.Fragment key={province}>
              {renderProvince(region, province)}
            </React.Fragment>
          ))}
        </StateSection>
      );
    })}
  </>
);

export default AdditionalRegionSections;
